import { IColumn } from '../../components';

export const SalonPlansColumns: IColumn[] = [
  {
    id: 'title',
    name: 'Name',
    width: '50%',
  },
  {
    id: 'lastModified',
    name: 'Last Modified',
    width: '50%',
  },
] as const;

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const quarterMonths = [
  ['January', 'February', 'March'],
  ['April', 'May', 'June'],
  ['July', 'August', 'September'],
  ['October', 'November', 'December'],
];
